import type { AxiosError, Method } from 'axios';

import {
  ApiResponseError,
  ClientApiError,
  type ProblemDetails,
  VersionMismatchError,
} from './apiError';

const isEmptyErrorResponse = (err: AxiosError): err is AxiosError<null> =>
  !err.response;

const isProblemDetailsResponse = (
  err: AxiosError,
): err is AxiosError<ProblemDetails> =>
  err.response &&
  err.response.headers['content-type'] &&
  err.response.headers['content-type'].startsWith('application/problem+json');

export const logResponseErrorInterceptor = (err: AxiosError | Error): void => {
  if (!('config' in err)) {
    throw err;
  }

  if (err?.config?.headers?.Authorization) {
    err.config.headers.Authorization = '[REDACTED]';
  }

  if (isEmptyErrorResponse(err)) {
    throw new ClientApiError(err);
  }

  if (isProblemDetailsResponse(err)) {
    if (
      err.response?.status === 412 &&
      err.response?.data.title === 'version-mismatch'
    ) {
      throw new VersionMismatchError(err);
    }

    throw new ApiResponseError(err);
  }

  throw err;
};

export interface HttpData {
  method?: Method;
  url?: string;
  traceId?: string;
  reason?: string;
  status_code?: number;
  originalError?: Error;
}
